import { setup } from 'bem-cn'
import React, { Component } from 'react'
import { DragSource } from 'react-dnd'
import { connect } from 'react-redux'
import { ItemTypes } from '../../constants'
import { changeTaskDates, resetCurrentTask, setCurrentTask } from '../../store/actions'
import { calculateNewDates } from '../../utils'

const block = setup({
    mod: '--'
})

const b = block('CalendarTask')

const handleSource = {
    beginDrag(props) {
        props.dispatch(setCurrentTask(props.task))

        return {
            task: props.task,
            type: props.type,
            startDate: props.startDate,
            endDate: props.endDate,
            moveDate: props.moveDate,
            duration: props.duration
        }
    },

    endDrag(props, monitor) {
        const taskInfo = monitor.getItem()
        const dropInfo = monitor.getDropResult()
        props.dispatch(resetCurrentTask())

        if (taskInfo && dropInfo) {
            const newDates = calculateNewDates(
                taskInfo.type,
                dropInfo.date,
                taskInfo.startDate,
                taskInfo.endDate,
                taskInfo.moveDate,
                taskInfo.duration
            )
            props.dispatch(changeTaskDates(taskInfo.task, (taskInfo.type === 'move' ? 'move' : 'resize'), newDates.startDate, newDates.endDate))
        }
    }
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
}

class Handle extends Component {
    render() {
        const { connectDragSource, type } = this.props

        return connectDragSource(<div className={b('drag-handle', { [type]: true })} />)
    }
}

export default connect()(DragSource(ItemTypes.HANDLE, handleSource, collect)(Handle))
